import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../Utils/apiClient';
import { toastSuccess, toastError } from '../Utils/toast';
const _ = require('lodash');

export class AddService extends Component {
        constructor(props) {
            super(props);
            this.state = {
                ServiceId: 0,
                formValues: [{ name: "", description : "" ,short: "", status : ""}],
                service_fields : [],
                messageSuccess: "",
                messageError: []
            }
            this.handleSubmit = this.handleSubmit.bind(this);
        } 
        mainChange(i, e) {
            let formValues = this.state.formValues;
            formValues[i][e.target.name] = e.target.value;
            this.setState({ formValues });
        }
    
        handleCompanyValueChange(i, e) {
            let service_fields = this.state.service_fields;
            if (service_fields[i].id) {
                service_fields[i].value = e.target.value;
    
            } else {
                service_fields[i]['value'] = e.target.value;
            }
            this.setState({ service_fields });
        }
        handleCompanyNameChange(i, e) {
            let service_fields = this.state.service_fields;
            if (service_fields[i].id) {
                service_fields[i].name = e.target.value;
    
            } else {
                service_fields[i]['name'] = e.target.value;
            }
            this.setState({ service_fields });
        }

        addFormFields() {
            this.setState(({
                service_fields: [...this.state.service_fields, {}]
            }))
        }
    
        async removeFormFields(i, el) {
            if (!_.isEmpty(el[i])) {
                let res = await
                    apiClient.delete('services/fields/' + el[i].id)
                        .then(response => { console.log(response) })
                        .catch(error => {
                            console.error('Error fetching data:', error);
                        });
            }
            let service_fields = this.state.service_fields;
            service_fields.splice(i, 1);
            this.setState({ service_fields });
        }

        handleSubmit = async (e) => {
            e.preventDefault(); 
            let mainvalue = this.state.formValues[0];
            let extvalue = this.state.service_fields;
           
            try {
                var postdata = {
                    name: mainvalue.name,
                    short: mainvalue.short,
                    status: mainvalue.status,
                    description: mainvalue.description,
                    service_fields: extvalue,
                };
                let res = await apiClient.post('services', postdata);
                let resJson = res.data;
                if (resJson.error === false) {
                    if(resJson.data) {
                        var errorObj = []
                        resJson.data.forEach(element => {
                            errorObj[element.field] = (errorObj[element.field])? errorObj[element.field] + ', ' + element.message: element.message
                        });
                        this.setState({ messageError: errorObj});
                    } else {
                        this.setState({ messageError: resJson.data});
                    }
                    toastError('Failed to create service');
                }
                if (resJson && resJson.success) {
                    this.setState({ messageSuccess:  "Service has been registered!!"});
                    toastSuccess('Service created');
                    this.setState({
                        formValues: [{ name: "", description : "" ,short: "", status : ""}],
                        extraValues: [{ extraname: "", extravalue : "" }]
                    })
                }
            } catch (err) {
                console.log(err);
                this.setState({ messageError:  "Some error occured"});
                toastError(err.response?.data?.message || 'Some error occurred');

            }
        };
        render() { 
            return (
                <div className="main-panel">
                    <div className="content-wrapper service_wrap">
                        <div className="card registration_form" >
                            <div className="modal-header">
                                <h3 className="card-heading">New Service</h3> 
                            </div>
                            <form onSubmit={this.handleSubmit} id='service_form'>   
                                <div className="modal-body">
                                    <div className="message"> 
                                        {
                                            this.state.messageSuccess ? <p className='alert alert-success'>{this.state.messageSuccess}</p> 
                                            : (this.state.messageError && !Array.isArray(this.state.messageError) ) ? <p className='alert alert-warning'>{this.state.messageError}</p> 
                                            : null
                                        } 
                                    </div> 
                                        {this.state.formValues.map((ele, inx) => (
                                            <div className='row' key={inx}>
                                                <div className='col-lg-6'>
                                                    <div className="form-group text-left">
                                                        <label className="form-group-text">Name</label>
                                                        <input type="text" className="form-control" name="name"
                                                            value={ele.name}
                                                            onChange={e =>this.mainChange(inx, e)} />
                                                        {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['name']}</span>}
                                                    </div>
                                                </div>
                                                <div className='col-lg-6'>
                                                    <div className="form-group text-left">
                                                        <label className="form-group-text">Short Name</label>
                                                        <input type="text" className="form-control" name ="short"
                                                            value={ele.short}
                                                            onChange={e =>this.mainChange(inx, e)} />
                                                        {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['short']}</span>}
                                                    </div>
                                                </div>
                                                <div className='col-lg-12'>
                                                    <div className="form-group text-left">
                                                        <label className="form-group-text">Description</label>  
                                                        <textarea className="form-control" name ="description" rows="4"
                                                            value={ele.description}
                                                            onChange={e =>this.mainChange(inx, e)} />
                                                        {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['description']}</span>}
                                                    </div>
                                                </div>
                                                
                                                <div className='col-lg-6'>
                                                    <div className="form-group text-left">
                                                        <label className="form-group-text">Status</label>
                                                        <select className="form-select form-control"
                                                            onChange={e =>this.mainChange(inx, e)} name="status"
                                                            value={ele.status}>
                                                            <option value="">-</option>
                                                            <option value="true">Active</option>
                                                            <option value="false">In Active</option>
                                                        </select>
                                                        {this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['status']}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        <h4 className='text-left'>Extra fields</h4>
                                        {this.state.service_fields.map((element, index) => (
                                            <div className='row form-group' key={index} >
                                                <div className='col-lg-6'>
                                                    <input type="text" className="form-control" name ="extraname" placeholder='name add here..'
                                                        value={(element.name) ?? ''}
                                                        onChange={e => this.handleCompanyNameChange(index, e)} />
                                                </div>
                                                <div className='col-lg-6'>
                                                    <input type="text" className="form-control" name ="extravalue" placeholder='value add here..'
                                                        value={(element.value) ?? ''}
                                                        onChange={e => this.handleCompanyValueChange(index, e)} />
                                                    {
                                                        index ? 
                                                        <button type="button"  className="btn btn-warning btn-icon btn-rounded float-right mt-1 remove" onClick={() => this.removeFormFields(index)}><i className='bi bi-dash-lg'></i></button> 
                                                        : null
                                                    }
                                                </div>                                                
                                                <div className='col-lg-12'>{this.state.messageError && <span className='text text-danger text-small'>{this.state.messageError['service_fields']}</span>} </div>
                                            </div>
                                            
                                        ))}
                                        <button className="btn btn-primary btn-icon btn-rounded float-right" type="button" onClick={() => this.addFormFields()}><i className='bi bi-plus'></i></button>
                                        <div className='clearfix'></div>
                                    </div>
                                <div className="modal-footer">                                    
                                        <button type="submit"
                                            className="btn btn-primary float-start"                                       
                                        >Create</button>    
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            );
        }
}
